import { getCurrentHostAndPath, isLinkOut, redirectToWithPageReload, trackEvent } from 'utils';

/**
 * Handles the click event for software download buttons.
 * Tracks the download event and redirects to the download URL.
 *
 * @param url - The download URL
 * @param operatingSystem - The user's operating system (e.g., 'Windows', 'macOS', 'Linux')
 */
export function handleRedirectToSoftwareDownloadPageClick(url: string, operatingSystem: string): void {
  const isExternalUrl = isLinkOut(url, window ? window.location.origin : '');

  if (isExternalUrl) {
    trackEvent('Link-Out', url, getCurrentHostAndPath());
  } else {
    trackEvent('Download', 'Fotobuch', operatingSystem);
  }

  redirectToWithPageReload(url);
}
